import { render, staticRenderFns } from "./MockIdentityTips.vue?vue&type=template&id=a079076e"
import script from "./MockIdentityTips.vue?vue&type=script&lang=js"
export * from "./MockIdentityTips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports